import { render, staticRenderFns } from "./Comment.vue?vue&type=template&id=36b76f86&"
import script from "./Comment.vue?vue&type=script&lang=ts&"
export * from "./Comment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports